import { combineReducers } from "@reduxjs/toolkit";
import displaySpecialities from "./displaySpecialitiesSlice";

const reducer = combineReducers({
  displaySpecialities,
});

export default reducer;
